import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { classNames } from "@/utils/classNames";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";

import {
	setSendErrorRange,
	supportDashboardSelector,
} from "@/pages/Private/redux/support-dashboard/support-dashboard.slice";

import { SEND_ERROR_RANGES, SendErrorRange } from "../schema/support-dashboard";

const RANGE_LABEL_KEYS: Record<SendErrorRange, string> = {
	TODAY: "supportDashboard.range.today",
	YESTERDAY: "supportDashboard.range.yesterday",
	LAST_7_DAYS: "supportDashboard.range.last7Days",
	LAST_30_DAYS: "supportDashboard.range.last30Days",
};

export const SendErrorRangeSelect: FunctionComponent = () => {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	const { sendErrorRange } = useAppSelector(supportDashboardSelector);

	return (
		<div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center">
			<span className="text-xs font-medium text-text-meta">
				{t("supportDashboard.range.label")}
			</span>
			<div className="inline-flex rounded-lg border border-border-light bg-brand-white p-0.5">
				{SEND_ERROR_RANGES.map((range) => (
					<button
						key={range}
						className={classNames(
							"rounded-md px-3 py-1.5 text-xs font-medium transition-colors",
							sendErrorRange === range
								? "bg-blue-action text-brand-white"
								: "text-text-meta hover:text-text"
						)}
						type="button"
						onClick={() => dispatch(setSendErrorRange(range))}
					>
						{t(RANGE_LABEL_KEYS[range])}
					</button>
				))}
			</div>
		</div>
	);
};
